module.exports = __webpack_public_path__ + "img/010028.9f29b823.png";